export const genericErrorRetry =
  'Oops! It looks like something went wrong. Please wait a few minutes and refresh the page. If this error persists, get in touch with customer support.'
